import { assoc, compose, isEmpty, propOr, when } from 'ramda';
import { buildTabsWithHealthInsurances } from './buildTabsWithHealthInsurances.js';

const hasTabs = compose(
  tabs => tabs && !isEmpty(tabs),
  propOr([], 'tabs')
);

export const enrichRODataWithTabs = (roData, params) => {
  return when(
    hasTabs,
    data => {
      const tabsWithHealthInsurances = buildTabsWithHealthInsurances({
        tabs: data.tabs,
        ...params
      });
      return assoc('tabs', tabsWithHealthInsurances, data);
    }
  )(roData);
};
